import { Redirect } from 'expo-router'
import { FC } from 'react'

const Page: FC = () => {
    return <Redirect href="/phone/1-product-catalog" />
}

export default Page
